<app-header-nav></app-header-nav>
<div class="min-h-screen flex items-center justify-center bg-gray-50 p-4">
  <mat-card class="w-full max-w-sm p-6">
    <div class="flex items-center mb-6">
      <button mat-icon-button (click)="onBack()"><mat-icon>arrow_back</mat-icon></button>
      <h2 class="text-2xl font-bold ml-2">Change Password</h2>
    </div>

    <form [formGroup]="form" (ngSubmit)="submit()">
      <mat-form-field class="w-full mb-4">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email" type="email">
      </mat-form-field>

      <mat-form-field class="w-full mb-4">
        <mat-label>Current Password</mat-label>
        <input matInput formControlName="oldPassword" [type]="hideOld ? 'password' : 'text'">
        <button mat-icon-button matSuffix type="button" (click)="hideOld = !hideOld">
          <mat-icon>{{ hideOld ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field class="w-full mb-4">
        <mat-label>New Password</mat-label>
        <input matInput formControlName="newPassword" [type]="hideNew ? 'password' : 'text'">
        <button mat-icon-button matSuffix type="button" (click)="hideNew = !hideNew">
          <mat-icon>{{ hideNew ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="form.get('newPassword')?.hasError('minlength')">Minimum 8 characters</mat-error>
      </mat-form-field>

      <button mat-raised-button color="primary" class="w-full" type="submit" [disabled]="loading || form.invalid">
        <mat-spinner *ngIf="loading" diameter="20" class="inline-block mr-2"></mat-spinner>
        Change Password
      </button>
    </form>
  </mat-card>
</div>
<app-footer></app-footer>
